import { render, staticRenderFns } from "./AssignContactsRequiringRebuild.vue?vue&type=template&id=54f8933e&scoped=true"
import script from "./AssignContactsRequiringRebuild.vue?vue&type=script&lang=js"
export * from "./AssignContactsRequiringRebuild.vue?vue&type=script&lang=js"
import style0 from "./AssignContactsRequiringRebuild.vue?vue&type=style&index=0&id=54f8933e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f8933e",
  null
  
)

export default component.exports